import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xl,

    padding: SPACES.xxl,

    minHeight: 340,
    maxHeight: 'calc(100vh - 80px)',
    maxWidth: 'calc(100vw - 40px)',
  },

  tableHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    '&&': {
      textAlign: 'center',
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },
  button: {
    border: `1px solid ${theme.palette.custom.grey3}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 40,
    borderRadius: '50%',
    cursor: 'pointer',
    '&&:hover': {
      border: `1px solid ${theme.palette.custom.darkBlue2}`,
    },

    '&&:active': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  cellDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  codeWrapper: {
    display: 'flex',
  },

  keyStyle: {
    fontWeight: 700,
    display: 'flex',
    alignItems: 'flex-start',
  },
  valStyle: {
    display: 'flex',
    alignItems: 'flex-start',
    wordBreak: 'break-word',
  },
}))
